<template>
  <div class="family-residents">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <div class="row pl-3 pt-3 pr-3 pb-0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1 class="title-pages pl-0 check-text-center">RESIDENTES</h1>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-search mr-1 icon-search"></i> Pesquisar
          </p>
          <v-text-field
            placeholder="Nome do residente"
            label="Informe o nome do residente"
            outlined
            @keyup="filterResidents($event.target.value)"
          />
        </div>
      </div>
      <b-overlay class="pl-2 pt-0 pr-2" :show="loading" opacity="0.99">
        <div class="row">
          <div
            class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-1 pb-5"
            v-for="resident in residents"
            :key="resident.id"
            @click="handleToResident(resident.id)"
          >
            <div
              class="
                card card-resident
                col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                pt-0
                pb-0
              "
            >
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h5 class="text-fifteen mb-0 upper-text">
                    {{ resident.name }}
                  </h5>
                  <!-- <p class="worksansr upper-text text-fifteen mb-0">
                    {{ getAge(resident.date_of_birth) }} ANOS
                  </p> -->
                  <div slot="footer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ErrorsMessages :errors="errors" />
        <div
          class="text-center v-clean p-5"
          v-show="residents.length == 0 && errors.length == 0"
        >
          <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../NavBar";

import AuthBySessionExpired from "../Components/AuthBySessionExpired";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import { getAge } from "../../lib/getAgeByDate";

import routes from "../../routes";

export default {
  name: "Dashboard",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },
  data() {
    return {
      loading: false,
      filter: [],
      residents: [],
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    filterResidents(value) {
      let { filter } = this;

      let residents = filter.filter(
        (obj) =>
          String(String(obj.name).toLowerCase()).indexOf(
            String(value).toLowerCase()
          ) > -1
      );

      this.residents = residents;
    },
    async retrieve() {
      this.getResidents();
    },
    async getResidents() {
      try {
        this.loading = true;

        let params = { status: "ATIVO" };

        const response = await api.get("/rest-home/resident/paginate", {
          params,
        });

        const { residents, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.filter = residents;
          this.residents = residents;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToResident: (id) =>
      routes.push({
        name: "family_resident",
        params: { id },
      }),
  },
};
</script>

<style>
.family-residents .card-resident {
  cursor: pointer;
}
</style>